import {
  handleAccountTypeSelection,
  handleCustomFromDateChange,
  handleCustomToDateChange,
  handleDateRangeReset,
  handlePeriodChange,
  toggleCustomDateFilter
} from './PerformancePageUtils';
import {
  getSelectedAccountTypeActionForFilterType,
  getSelectedCustomFromDateActionForFilterType,
  getSelectedCustomToDateActionForFilterType,
  getSelectedPeriodActionForFilterType,
  getToggledCustomDateActionForFilterType,
  RESET_FILTERS_FOR_ACCOUNT_DETAILS,
  RESET_FILTERS_FOR_PERFORMANCE
} from './PerformancePageActions';
import {
  initialDateRangeFilter,
  initialSinceInceptionDateRangeFilter
} from 'services/Filters';

export const BaseFilterReducer =
  (filterType) =>
  (state = {}, action) => {
    switch (action.type) {
      case RESET_FILTERS_FOR_ACCOUNT_DETAILS:
        return handleDateRangeReset(
          state,
          initialSinceInceptionDateRangeFilter
        );
      case RESET_FILTERS_FOR_PERFORMANCE:
        return handleDateRangeReset(state, initialDateRangeFilter);
      case getSelectedAccountTypeActionForFilterType(filterType):
        return handleAccountTypeSelection(state, action);
      case getSelectedPeriodActionForFilterType(filterType):
        return handlePeriodChange(state, action);
      case getSelectedCustomFromDateActionForFilterType(filterType):
        return handleCustomFromDateChange(state, action);
      case getSelectedCustomToDateActionForFilterType(filterType):
        return handleCustomToDateChange(state, action);
      case getToggledCustomDateActionForFilterType(filterType):
        return toggleCustomDateFilter(state, action);
      default:
        return state;
    }
  };
